import { render, staticRenderFns } from "./modal-previewemailtemplate.vue?vue&type=template&id=3df8e1ff&scoped=true&"
import script from "./modal-previewemailtemplate.vue?vue&type=script&lang=js&"
export * from "./modal-previewemailtemplate.vue?vue&type=script&lang=js&"
import style0 from "./modal-previewemailtemplate.vue?vue&type=style&index=0&id=3df8e1ff&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3df8e1ff",
  null
  
)

export default component.exports